import React, { useState, useEffect, Fragment } from "react";
import { useParams } from 'react-router-dom';
import axios from 'axios';
import { CSSTransition } from 'react-transition-group';
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import AspectRatioBox from "./aspectRatioUtil";
import Loader from '../static/svg/loader.svg';

import configData from "../config.json";

function getMedia(path) {
  return configData.API_URL + path;
}

gsap.registerPlugin(ScrollTrigger);

function Product(props) {

    let {productSlug} = useParams();

    const [loaded, setLoaded] = useState(false);
    const [product, setProduct] = useState();

    function getMediaPath(path, path_m) {
      let r;
      if (props.isMobile) {
        if (path_m) {
          r = configData.API_URL + path_m
        } else {
          r = configData.API_URL + path
        }

      } else {
        r = configData.API_URL + path
      }

      return r;
    }

    const getProduct = async() => {
        setProduct(null);
        setLoaded(false);
        await axios({
          method: 'get',
          url: configData.API_URL + "/api/product/" + productSlug
          })
          .then(response => {
            const dataJSON = response.data;
            setProduct(dataJSON);
            console.log('product', dataJSON)
          });
      }


    useEffect(() => {
      let rowTl0;
      let rowTl1;

        if (product) {
             setLoaded(true)
  
            props.footerColor('auto');
         

          rowTl0 = gsap.timeline({
            defaults: {
              ease: "power1",
            },
          });
          rowTl0.fromTo("#productHeader h1", {translateY: "40px"}, {translateY: "0"});
          rowTl0.fromTo("#productHeader h1", {opacity: 0}, {opacity: 1},"<");
          // rowTl0.fromTo("#productHeader h2", {translateY: "40px"}, {translateY: "0"});
          // rowTl0.fromTo("#productHeader h2", {opacity: 0}, {opacity: 1},"<");
          rowTl0.fromTo("#productHeader h3", {translateY: "40px"}, {translateY: "0"});
          rowTl0.fromTo("#productHeader h3", {opacity: 0}, {opacity: 1},"<");

          if (product.productfiles && product.productfiles.length > 0) {
            rowTl1 = gsap.timeline({
              defaults: {
                duration: 0.6,
                ease: "power1",
              },
              scrollTrigger: {
                trigger: "#productFiles",
                start: "center 80%",
                end: "top top",
                scrub: 1,
                markers: false
              }
            });
            let fileObjs = document.querySelectorAll('.productFile');
            fileObjs.forEach((obj, i) => {
              rowTl1.fromTo(obj, {translateY: "40px"}, {translateY: "0"}, "<");
              rowTl1.fromTo(obj, {opacity: 0}, {opacity: 1}, "<");
            });
          }
        }
        return () => {
          if (rowTl0) rowTl0.kill();
          if (rowTl1) rowTl1.kill();
        };
    }, [product, props]);

    useEffect(() => {
      if (productSlug) {
        getProduct();
          props.menuColor('none');
      props.accentColor('#FFFFFF');
      props.logoColor('fillBlack');
      }
    }, [productSlug]);

    useEffect(() => {
      document.title = product ? product.heading + " | " + configData.BASE_TITLE : configData.BASE_TITLE;
    }, [product]);

    return (
        <div className="page productPage">
            <CSSTransition in={loaded} timeout={100} unmountOnExitclassNames="fade">
                <div className="column">
                {product &&
                  <Fragment>
                    <div className="container" id="productHeader">
                      <div className="row">
                        <div className="col-12">
                          {product.logo &&
                            <div className="productLogo">
                              <img src={getMedia(product.logo)} alt={product.heading} />
                            </div>
                          }
                           <div className={`heading row0`}>
                            <h1 style={{maxWidth: '90%', paddingBottom: '20px'}}>{product.heading}</h1>
                              {product.subheading &&
                            <h3>{product.subheading}</h3>
                          }
                          {product.text &&
                            <AspectRatioBox tag="h3" classes={['alt']} content={product.text} fonts={props.fonts} isMobile={props.isMobile} />
                          }
                           </div>

                        
                          
                          {product.link_heading && product.link &&
                            <div className="pillBtn">
                              <a href={product.link} target="_blank" rel="noopener noreferrer">
                                {product.link_heading}
                              </a>
                            </div>
                          }
                        </div>
                      </div>
                    </div>

                    {product.productfiles && product.productfiles.length > 0 &&
                      <div className="container" id="productFiles">
                        <div className="row">
                          {product.productfiles.map((file, index) => (
                            <div key={file.id} className="col-12 productFile">
                              {file.file &&
                                <Fragment>
                                  {file.file_type === '.mp4' || file.file_type === '.webm' ? (
                                    <video
                                      src={getMediaPath(file.file, file.file_m)}
                                      autoPlay
                                      muted
                                      loop={file.loop}
                                      playsInline
                                      style={file.aspect_ratio ? {aspectRatio: file.aspect_ratio, height: 'auto', width: '100%'} : {}}
                                    />
                                  ) : (
                                    <img
                                      src={getMediaPath(file.file, file.file_m)}
                                      alt={file.file_alt || product.heading}
                                    />
                                  )}
                                  {file.caption &&
                                    <p className="caption">{file.caption}</p>
                                  }
                                </Fragment>
                          
                              }
                            </div>
                          ))}
                        </div>
                      </div>
                    }

                        {product.cta && product.link && product.link_heading &&
                          <span className="row pageRow ctaRow">
                          <p>{product.cta}</p>
                           <div className="pillBtn">
                              <a href={product.link} target="_blank" rel="noopener noreferrer">
                                {product.link_heading}
                              </a>
                            </div>

                          </span>
                           
                          }


                  </Fragment>
                }
                </div>
            </CSSTransition>
            <CSSTransition in={!loaded} timeout={100} unmountOnExit classNames="fade">
                <div className="loader">
                    <img src={Loader} alt="loading" />
                </div>
            </CSSTransition>
        </div>
    );
}

export default Product;
